export default __webpack_public_path__ + "static/media/click1.f5471475.ogg";